module.exports = __webpack_public_path__ + "static/media/1.8514cc88.png";